import { Briefcase, Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DOCUMENT_TYPE_LABELS } from "./Exports.constants";

export default function GeneratorsGrid({ busy, generate, tasks, selectedTaskId, setSelectedTaskId, generatorCards }) {
  return (
    <section className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-testid="exports-generators">
      {generatorCards.map(({ kind, key, icon: Icon, color, description }) => (
        <Card key={kind} className="shadow-none">
          <CardHeader className="pb-2">
            <div className={`flex items-center gap-2 ${color}`}>
              <Icon className="h-5 w-5" />
              <CardTitle className="font-heading text-base">{DOCUMENT_TYPE_LABELS[key]}</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-sm text-slate-600">{description}</p>
            <Button onClick={() => generate(kind)} disabled={busy === kind} className="bg-blue-900 hover:bg-blue-800" data-testid={`generate-${key}-button`}>
              {busy === kind ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
              {busy === kind ? "Generazione..." : "Genera"}
            </Button>
          </CardContent>
        </Card>
      ))}

      <Card className="shadow-none md:col-span-2 lg:col-span-3" data-testid="exports-task-card">
        <CardHeader className="pb-2">
          <div className="flex items-center gap-2 text-cyan-700">
            <Briefcase className="h-5 w-5" />
            <CardTitle className="font-heading text-base">Estratto per mansione</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-3">
          <p className="text-sm text-slate-600">Genera un estratto PDF con rischi, DPI e formazione riferiti a una mansione specifica.</p>
          <div className="flex flex-wrap items-center gap-3">
            <select
              className="h-9 rounded-md border border-slate-200 bg-white px-3 text-sm"
              value={selectedTaskId}
              onChange={(e) => setSelectedTaskId(e.target.value)}
              data-testid="exports-task-select"
            >
              {tasks.length === 0 && <option value="">Nessuna mansione disponibile</option>}
              {tasks.map((t) => <option key={t.id} value={t.id}>{t.name || t.code || t.id}</option>)}
            </select>
            <Button
              disabled={!selectedTaskId || busy.startsWith("task-extract")}
              onClick={() => generate("task-extract", { taskId: selectedTaskId })}
              className="bg-blue-900 hover:bg-blue-800"
              data-testid="generate-task-extract-button"
            >
              {busy.startsWith("task-extract") ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
              {busy.startsWith("task-extract") ? "Generazione..." : "Genera estratto"}
            </Button>
          </div>
        </CardContent>
      </Card>
    </section>
  );
}
